import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { AlertDialogActionProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { AlertDialogAction } from "reka-ui"
import { cn } from "@/lib/utils"
import { buttonVariants } from '@/components/ui/button'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertDialogAction',
  props: {
    asChild: { type: Boolean },
    as: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialogAction), _mergeProps(_unref(delegatedProps), {
    class: _unref(cn)(_unref(buttonVariants)(), props.class)
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})